// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C_COa","name":"styles_name__qAOFL","phone":"styles_phone__ogC53"};